module.exports = __webpack_public_path__ + "img/T5-D-rc_18.cd46b17d.png";